import React from "react";
import { ScanReportType } from "@sscs/types";
import { SharedReportStats } from "Types";
import LinksTable from "./LinksTable/LinksTable";

type LinksAndStatisticsProps = {
  versionId: string;
  purl: string;
  reportType?: ScanReportType;
  stats: SharedReportStats | null;
  openShareReportDialog: () => void;
};

const LinksAndStatistics = ({
  versionId,
  purl,
  reportType,
  stats,
  openShareReportDialog,
}: LinksAndStatisticsProps): React.JSX.Element => (
  <LinksTable
    versionId={versionId}
    purl={purl}
    reportType={reportType}
    stats={stats}
    openShareReportDialog={openShareReportDialog}
  />
);

export default LinksAndStatistics;
